// extracted by mini-css-extract-plugin
export default {"error":"info__error-GQ6Fw","warning":"info__warning-RmGN4","normal":"info__normal-go1bS"};